(ns ycweb.app.website.demo.keepaside
  (:require
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.forms :as input-forms]
   [ycweb.util.core :as u]
   [ycweb.components.forms :as forms]))

(rum/defc keep-aside
  [app-atom
   {:keys []
    :as options}]
  (buttons/button-web "Find in store"
    {:type :button
     ;; TODO: add an :on-click here
     :on-click #(grid/open-modal app-atom :demo/keepaside)
     :style :secondary
     :size :default
     :icon :location}))


;; Modal Step 1
(rum/defcs keep-aside-1a-modal-body < rum/reactive [app-atom dumb-atom]
  (list
    (headings/heading "Check store availability"
      {:type :h2
       :size :default})
    [:p.yc-paragraph [:b "KitchenAid Artisan 4.8L Stand Mixer"]]
    [:p.yc-paragraph "Which variations are you looking for?"]
    [:div.form-field
     ;; TODO: switch out the wording to be "size", "packsize" etc..
     (input-forms/radio "All colours" "radio-all-colours" (rum/cursor dumb-atom :demo/variation))]
    [:div.form-field
     (input-forms/radio "Specific colours" "radio-specific-colours" (rum/cursor dumb-atom :demo/variation))]))

(rum/defc keep-aside-1a-modal-footer [app-atom]
  [[:div
    {:class (u/bem :flex-grid-group [:flush])}
    [:div
     {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
     (buttons/button-web "Next"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom)
          ;; TODO: link this to the next modal step
          (grid/open-modal app-atom :demo/keepaside2))
        :style :primary
        :size :large
        :full true
        :icon :arrow-right
        :icon-placement :right
        :persistent true
        :flat-style :flat})]
    [:div
     {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
     (buttons/button-web "Cancel"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom))
        :style :secondary-noborder
        :size :large
        :full true
        :persistent true
        :flat-style :flat})]]])

(defmethod grid/modal-config :demo/keepaside [_ _ _]
  {:body keep-aside-1a-modal-body
   :footer keep-aside-1a-modal-footer
   :modal-type :variable})


;; Modal Step 2

;; Variation checkbox component
;; Note from Jon: This is a new component. Please don't try tweak an existing form component.
;; I've created this simple component in the meantime. I'll leave it up to a dev to make the call on whether to use a different method or not.
(rum/defc variation-checkbox
  [{:keys [hex-colour variation]
    :as options}]
  [:label.var-checkbox
   [:input.var-checkbox__input.u-hidden-from-view
    {:type "checkbox"}]
   [:span.var-checkbox__button
    [:span.var-checkbox__graphic-wrapper
     [:span.var-checkbox__graphic
      ;; TODO: If it's a colour, we get the variation colour from colours.php and set it as the background colour here.
      {:style {:background-color hex-colour}}]]
    [:span.var-checkbox__text variation]]])

(rum/defcs keep-aside-2a-modal-body < rum/reactive []
  (list
    (headings/heading "Check store availability"
      {:type :h2
       :size :default})
    [:p.yc-paragraph [:b "KitchenAid Artisan 4.8L Stand Mixer"]]
    [:p.yc-paragraph "Choose the colour you're looking for"]
    ;; TODO: We need to loop through all variations and display them as these custom checkboxes. Customers can choose to show all variations (which will disable the other checkboxes), or show only specific variations in the in-store results. I have demo'd this with jQuery.
    [:div.u-margin-bottom-16
     (variation-checkbox
       {:hex-colour "#deb9b7"
        :variation "Dried Rose"})
     (variation-checkbox
       {:hex-colour "#dfdf7d"
        :variation "Kyoto Glow"})
     (variation-checkbox
       {:hex-colour "#3e4f50"
        :variation "Pebble Palm"})
     (variation-checkbox
       {:hex-colour "#648fb2"
        :variation "Blue Velvet"})
     (variation-checkbox
       {:hex-colour "#c0e1c0"
        :variation "Pistachio"})
     (variation-checkbox
       {:hex-colour "#afd5d6"
        :variation "Ice Blue"})
     (variation-checkbox
       {:hex-colour "#b82525"
        :variation "Candy Apple"})
     (variation-checkbox
       {:hex-colour "#d96161"
        :variation "Coral"})
     (variation-checkbox
       {:hex-colour "#b80710"
        :variation "Empire Red"})
     (variation-checkbox
       {:hex-colour "#efcbcd"
        :variation "Silky Pink"})
     (variation-checkbox
       {:hex-colour "#000000"
        :variation "Onyx Black"})
     (variation-checkbox
       {:hex-colour "#757474"
        :variation "Medallion Silver"})
     (variation-checkbox
       {:hex-colour "#2f2f2f"
        :variation "Cast Iron"})
     (variation-checkbox
       {:hex-colour "#fdf5e0"
        :variation "Almond Cream"})
     (variation-checkbox
       {:hex-colour "#f2f2f2"
        :variation "White"})
     (variation-checkbox
       {:hex-colour "#ffe289"
        :variation "Majestic Yellow"})
     (variation-checkbox
       {:hex-colour "#9d9d9d"
        :variation "Contour Silver"})
     (variation-checkbox
       {:hex-colour "#202940"
        :variation "Ink Blue"})
     (variation-checkbox
       {:hex-colour "#cb886e"
        :variation "Satin Copper"})
     (variation-checkbox
       {:hex-colour "#5b334e"
        :variation "Boysenberry"})
     (variation-checkbox
       {:hex-colour "#e2e0e3"
        :variation "Frosted Pearl"})
     (variation-checkbox
       {:hex-colour "#958a88"
        :variation "Brushed Nickel"})
     (variation-checkbox
       {:hex-colour "#cbcbcf"
        :variation "Chrome"})]))

(rum/defc keep-aside-2a-modal-footer [app-atom]
  [[:div
    {:class (u/bem :flex-grid-group [:flush])}
    [:div
     {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
     (buttons/button-web "Next"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom)
          ;; links to next step
          (grid/open-modal app-atom :demo/keepaside3))
        :style :primary
        :size :large
        :full true
        :icon :arrow-right
        :icon-placement :right
        :persistent true
        :flat-style :flat})]
    [:div
     {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
     (buttons/button-web "Back"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom)
          ;; links to previous step
          (grid/open-modal app-atom :demo/keepaside))
        :style :secondary-noborder
        :size :large
        :full true
        :icon :arrow-left
        :persistent true
        :flat-style :flat})]]])

(defmethod grid/modal-config :demo/keepaside2 [_ _ _]
  {:body keep-aside-2a-modal-body
   :footer keep-aside-2a-modal-footer
   :modal-type :variable})


;; Modal Step 3
(rum/defcs keep-aside-3a-modal-body < rum/reactive [app-atom dumb-atom]
  (list
    (headings/heading "Check store availability"
      {:type :h2
       :size :default})
    ;; TODO: We need to populate which variation is selected, else all variations, else "selected variations"
    [:p.yc-paragraph [:b "KitchenAid Artisan 4.8L Stand Mixer"]]
    [:p.yc-paragraph "Find selected colours in your nearest store"]
    [:div.form-field.u-max-width-320
     ;; TODO: are we able to add the 'required' attribute to this component? (see HTML mockup)
     (forms/select "City:"
       (rum/cursor-in dumb-atom [:city])
       [{:value "" :text "Select"}
        {:value "cape-town" :text "Cape Town"}
        {:value "johannesburg" :text "Johannesburg"}])]
    ;; TODO: disable this dropdown until the user chooses a city, then only show stores relevant to that city.
    [:div.form-field.u-max-width-320
     (forms/select "Store:"
       (rum/cursor-in dumb-atom [:store])
       [{:value "all" :text "All stores"}
        {:value "waterfront" :text "V&A Waterfront"}
        {:value "westlake" :text "Westlake Outlet"}])]))

(rum/defc keep-aside-3a-modal-footer [app-atom]
  [[:div
    {:class (u/bem :flex-grid-group [:flush])}
    [:div
     {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
     (buttons/button-web "Next"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom)
          ;; TODO: link this to the next modal step
          (grid/open-modal app-atom :demo/keepaside4))
        :style :primary
        :size :large
        :full true
        :icon :arrow-right
        :icon-placement :right
        :persistent true
        :flat-style :flat})]
    [:div
     {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
     (buttons/button-web "Back"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom)
          ;; TODO: link this to the previous modal step
          (grid/open-modal app-atom :demo/keepaside2))
        :style :secondary-noborder
        :size :large
        :full true
        :icon :arrow-left
        :persistent true
        :flat-style :flat})]]])

(defmethod grid/modal-config :demo/keepaside3 [_ _ _]
  {:body keep-aside-3a-modal-body
   :footer keep-aside-3a-modal-footer
   :modal-type :variable})


;; Modal Step 4

;; Stock Card Component
(rum/defc stock-card
  [app-atom
   {:keys [title colours store
           sizes stock?]
    :as options}]
  [:article.store-stock-card
   {:class (u/bem :card [:no-hover])}
   [:header.store-stock-card__header
    [:h3.store-stock-card__title title]
    (when-not (or colours sizes)
      [:p.store-stock-card__status
       [:i.store-stock-card__icon
        {:class
         (u/bem :icon [(cond stock? :success-green :else :error-red) :in-copy-left :small :inline])}]
       [:b {:class (u/bem :text-status [(cond stock? :success :else :error)])}
        (cond stock? "In stock" :else "Out of stock")]])]

   (cond
     colours
     (into
       [:ul.store-stock-card-list]
       (map
         (fn [colour]
           [:li.store-stock-card-list__item
            [:div.store-stock-card-list__content
             [:div.store-stock-card-list__colour
              {:style {:background-color (:colour colour)}}]
             [:div.store-stock-card-list__details
              [:div.store-stock-card-list__name (:name colour)]
              [:div.store-stock-card-list__status
               [:i.store-stock-card__icon
                {:class
                 (u/bem :icon
                   [(cond (:in-stock colour) :success-green :else :error-red) :in-copy-left :small :inline])}]
               [:b {:class (u/bem :text-status [(cond (:in-stock colour) :success :else :error)])}
                (cond (:in-stock colour) "In stock" :else "Out of stock")]]]]])
         colours))

     sizes
     (into
       [:ul.store-stock-card-list]
       (map
         (fn [size]
           [:li.store-stock-card-list__item
            [:div.store-stock-card-list__details
             [:div.store-stock-card-list__name
              [:b (:name size)]]
             [:div.store-stock-card-list__status
              [:i.store-stock-card__icon
               {:class
                (u/bem :icon
                  [(cond (:in-stock size) :success-green :else :error-red) :in-copy-left :small :inline])}]
              [:b {:class (u/bem :text-status [(cond (:in-stock size) :success :else :error)])}
               (cond (:in-stock size) "In stock" :else "Out of stock")]]]])
         sizes)))

   [:div.store-stock-card__details
    [:p
     {:class (u/bem :yc-paragraph [:small])}
     (:address store)
     " "
     [:a.text-link
      {:href (:google-url store)}
      "Directions"]]
    [:p
     {:class (u/bem :yc-paragraph [:flush :small])}
     "Open until: " (:trading-hours-end store)]]
   [:footer.store-stock-card__footer
    {:class (u/bem :flex-grid-group [:valign-middle :flush])}
    [:div
     {:class (u/bem :flex-grid-block [:t-1-2 :flush])}
     [:div.flex-grid-content
      (buttons/button-web "Directions"
        {:href (:google-url store)
         :target "_blank"
         :style :secondary-noborder
         :size :default
         :flat-style :flat-to-raised
         :full true
         :icon :location})]]
    [:div
     {:class (u/bem :flex-grid-block [:t-1-2 :flush])}
     [:div.flex-grid-content
      (buttons/button-web "Keep aside"
        {:type :button
         :on-click
         (fn []
           (grid/close-modal app-atom)
           ;; TODO: link this to the previous modal step
           (grid/open-modal app-atom :demo/keepaside5))
         :style :primary
         :size :default
         :full true
         ;; TODO: if variation out of stock, then disable this button
         ;; :disabled true
         :flat-style :flat-to-raised
         :icon :shopping-bag})]]]])


(rum/defc keep-aside-4a-modal-body [app-atom]
  [[:h2 {:class (u/bem :yc-heading [:default])} "Check store availability"]
   [:p
    {:class (u/bem :yc-paragraph [:flush])}
    [:b "Bosch OptiMUM 5.5L Kitchen Machine, MUM9BX5S65"]]
   [:p.yc-paragraph "Showing all variations for all Cape Town stores"]

   (stock-card app-atom
     {:title "Yuppiechef Mall of Africa"
      :stock? true
      :store {:address "Shop 2126, Mall of Africa, Corner of Lone Creek Crescent and Magwa Crescent, Waterfall City."
              :google-url "https://goo.gl/maps/FN7U69RJEaaZVHRt9"
              :trading-hours-end "21:00"
              :tel "+27104467712"}})

   (stock-card app-atom
     {:title "Yuppiechef Mall of Africa"
      :colours [{:colour "#deb9b7"
                 :name "Dried Rose"
                 :in-stock true}
                {:colour "#dfdf7d"
                 :name "Cool Cucumber"
                 :in-stock true}
                {:colour "#c0e1c0"
                 :name "Hot Mess Red colour name is very long"}]
      :store {:address "Shop 2126, Mall of Africa, Corner of Lone Creek Crescent and Magwa Crescent, Waterfall City."
              :google-url "https://goo.gl/maps/FN7U69RJEaaZVHRt9"
              :trading-hours-end "21:00"
              :tel "+27104467712"}})

   (stock-card app-atom
     {:title "Yuppiechef Sandton City"
      :store {:address "Shop L337, Sandton City, Lower Level, 83 Rivonia Road, Sandhurst Ext 3"
              :google-url "https://goo.gl/maps/htYZyR6jEdmEh8sQ7"
              :trading-hours-end "21:00"
              :tel "+27104467711"}})])

(rum/defc keep-aside-4a-modal-footer [app-atom]
  [[:div
    {:class (u/bem :flex-grid-group [:flush])}
    [:div
     {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}]
    [:div
     {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
     (buttons/button-web "Back"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom)
          ;; TODO: link this to the previous modal step
          (grid/open-modal app-atom :demo/keepaside3))
        :style :secondary-noborder
        :size :large
        :full true
        :icon :arrow-left
        :persistent true
        :flat-style :flat})]]])


(defmethod grid/modal-config :demo/keepaside4 [_ _ _]
  {:body keep-aside-4a-modal-body
   :footer keep-aside-4a-modal-footer
   :modal-type :variable})

;; Modal Step 5
(rum/defc keep-aside-5a-modal-body [app-atom dumb-atom]
  (list
    (headings/heading "Keep aside in Yuppiechef Mall of Africa store"
      {:type :h2
       :size :default})
    ;; TODO: We need to populate which variation is selected, else all variations, else "specific variations"
    [:p.yc-paragraph [:b "KitchenAid Artisan 4.8L Stand Mixer"]]
    [:p.yc-paragraph "How many would you like us to keep aside?"]
    [:div.form-field.u-max-width-480]
    [:ul.store-stock-card-list
     [:li.store-stock-card-list__item
      [:div.store-stock-card-list__content
       [:div.store-stock-card-list__colour
        {:style {:background-color "#deb9b7"}}]
       [:div.store-stock-card-list__details
        [:div.store-stock-card-list__name "Dried Rose"]]]
      [:div.store-stock-card-list__qty
       (forms/select-raw
         (rum/cursor dumb-atom :keepaside/qty)
         [{:value 1 :text "1"}
          {:value 2 :text "2"}
          {:value 3 :text "3"}
          {:value 4 :text "4"}
          {:value 5 :text "5"}
          {:value 6 :text "6"}
          {:value 7 :text "7"}
          {:value 8 :text "8"}
          {:value 9 :text "9"}
          {:value 10 :text "10"}]
         {:inline? true})]]
     [:li.store-stock-card-list__item
      [:div.store-stock-card-list__content
       [:div.store-stock-card-list__colour
        {:style {:background-color "#dfdf7d"}}]
       [:div.store-stock-card-list__details
        [:div.store-stock-card-list__name "Cool Cucumber"]]]
      [:div.store-stock-card-list__qty
       (forms/select-raw
         (rum/cursor dumb-atom :keepaside/qty)
         [{:value 1 :text "1"}
          {:value 2 :text "2"}
          {:value 3 :text "3"}
          {:value 4 :text "4"}
          {:value 5 :text "5"}
          {:value 6 :text "6"}
          {:value 7 :text "7"}
          {:value 8 :text "8"}
          {:value 9 :text "9"}
          {:value 10 :text "10"}]
         {:inline? true})]]
     [:li.store-stock-card-list__item
      [:div.store-stock-card-list__content
       [:div.store-stock-card-list__colour
        {:style {:background-color "#c0e1c0"}}]
       [:div.store-stock-card-list__details
        [:div.store-stock-card-list__name
         "Hot Mess Red colour name is very, very unbelievably ridiculously long"]]]
      [:div.store-stock-card-list__qty
       (forms/select-raw
         (rum/cursor dumb-atom :keepaside/qty)
         [{:value 1 :text "1"}
          {:value 2 :text "2"}
          {:value 3 :text "3"}
          {:value 4 :text "4"}
          {:value 5 :text "5"}
          {:value 6 :text "6"}
          {:value 7 :text "7"}
          {:value 8 :text "8"}
          {:value 9 :text "9"}
          {:value 10 :text "10"}]
         {:inline? true})]]]))

(rum/defc keep-aside-5a-modal-footer [app-atom]
  [[:div
    {:class (u/bem :flex-grid-group [:flush])}
    [:div
     {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
     ;; TODO: disable this button until required fields are filled out
     (buttons/button-web "Next"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom)
          ;; TODO: link this to the next modal step
          (grid/open-modal app-atom :demo/keepaside6))
        :style :primary
        :size :large
        :full true
        :icon :arrow-right
        :icon-placement :right
        :persistent true
        :flat-style :flat})]
    [:div
     {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
     (buttons/button-web "Back"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom)
          ;; TODO: link this to the previous modal step
          (grid/open-modal app-atom :demo/keepaside4))
        :style :secondary-noborder
        :size :large
        :full true
        :icon :arrow-left
        :persistent true
        :flat-style :flat})]]])

(defmethod grid/modal-config :demo/keepaside5 [_ _ _]
  {:body keep-aside-5a-modal-body
   :footer keep-aside-5a-modal-footer
   :modal-type :variable})


;; Modal Step 6
(rum/defc keep-aside-6a-modal-body [app-atom dumb-atom]
  (list
    ;; TODO: pull in the selected store name here
    (headings/heading "Keep aside in Yuppiechef Mall of Africa store"
      {:type :h2
       :size :default})
    ;; TODO: We need to populate which variation is selected, else all variations, else "specific variations"
    [:p.yc-paragraph [:b "KitchenAid Artisan 4.8L Stand Mixer"]]
    [:p.yc-paragraph
     "Fill in your details so that we can keep aside your selected colours for you."]
    [:div.form-field.u-max-width-480
     (forms/split-input-field
       ["First name: (required)" "e.g. Jane"
        (rum/cursor dumb-atom :user/firstname)
        {:type :user :id :first-name :name :firstname :required? true}]
       ["Last name: (required)" "e.g. Smith"
        (rum/cursor dumb-atom :user/lastname)
        {:type :user :id :last-name :name :lastname :required? true}])]
    [:div.form-field.u-max-width-480
     (forms/input "Email address: (required)" "e.g. jane.smith@domain.com"
       (rum/cursor dumb-atom :user/email)
       {:type :email
        :id :email
        :name :email
        :required? true})]
    [:div.form-field.u-max-width-480
     (forms/input "Contact number: (required)" "e.g. 083 000 0000"
       (rum/cursor dumb-atom :user/tel)
       {:type :phone
        :id :tel
        :name :tel
        :required? true})]
    [:div.form-field
     (forms/checkbox "Sign up to our newsletter"
       (rum/cursor dumb-atom :user/notifynewsletter)
       {:id :notify-newsletter
        :name :newsletter
        :description "Be the first to know about our famous Tick Tick Tuesday deals and tempting new product releases."})]
    [:div.form-field
     (forms/checkbox "Personalised offers"
       (rum/cursor dumb-atom :user/notifypromotion)
       {:id :notify-promotions
        :name :promotions
        :description "Receive personalised vouchers or special offers for Yuppiechef, sent no more than a few times a year."})]))

(rum/defc keep-aside-6a-modal-footer [app-atom]
  [[:div
    {:class (u/bem :flex-grid-group [:flush])}
    [:div
     {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
     ;; TODO: disable this button until required fields are filled out
     (buttons/button-web "Submit"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom)
          ;; TODO: link this to the next modal step
          (grid/open-modal app-atom :demo/keepaside7))
        :style :primary
        :size :large
        :full true
        :persistent true
        :flat-style :flat})]
    [:div
     {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
     (buttons/button-web "Back"
       {:type :button
        :on-click
        (fn []
          (grid/close-modal app-atom)
          ;; TODO: link this to the previous modal step
          (grid/open-modal app-atom :demo/keepaside5))
        :style :secondary-noborder
        :size :large
        :full true
        :icon :arrow-left
        :persistent true
        :flat-style :flat})]]])

(defmethod grid/modal-config :demo/keepaside6 [_ _ _]
  {:body keep-aside-6a-modal-body
   :footer keep-aside-6a-modal-footer
   :modal-type :variable})


;; Modal Step 7
(rum/defc keep-aside-7a-modal-body []
  (list
    (headings/heading "Request received"
      {:type :h2
       :size :default})
    [:p.yc-paragraph
     "Thank you. We've received your request to keep aside the KitchenAid Artisan Stand Mixer for you in our "
     [:a.text-link {:href "#"} "Mall of Africa store"]
     "."]
    [:p.yc-paragraph
     "We'll send you an email to let you know once we've set aside the item(s) for you and it's/they're available for you to come in and take a look."]
    [:p.yc-paragraph
     [:b "Please note:"]
     " The item(s) will only be ready once you've received this confirmation email from us. Please show the email to any store assistant and they'll be able to help you."]))

(rum/defc keep-aside-7a-modal-footer [app-atom]
  (list
    [:div
     {:class (u/bem :flex-grid-group [:flush])}
     [:div
      {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
      (buttons/button-web "Done"
        {:type :button
         :on-click
         (fn []
           (grid/close-modal app-atom))
         :style :primary
         :size :large
         :full true
         :persistent true
         :flat-style :flat})]
     [:div
      {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
      (buttons/button-web "Return to homepage"
        {:href "/index.htm"
         :style :secondary-noborder
         :size :large
         :full true
         :icon :arrow-left
         :persistent true
         :flat-style :flat})]]))

(defmethod grid/modal-config :demo/keepaside7 [_ _ _]
  {:body keep-aside-7a-modal-body
   :footer keep-aside-7a-modal-footer
   :modal-type :variable})